// JAWS vs VoiceOver (see doc/jaws-voiceover-accessibility-reference.md §5):
// Question progress is an sr-only h2 (aria-describedby on the question h1).
// On question change, focus moves to the h1.

import React, { useLayoutEffect, useRef } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import WelcomePage from './WelcomePage'
import FormPage from './FormPage'
import { focusStepOnChange } from '../OnboardingSteps/Announcer'
import {
  SelectOnboardingProvider,
  queryClient,
  useSelectOnboarding,
} from './SelectOnboardingProvider'

const SelectOnboarding = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <SelectOnboardingProvider>
        {/* Plan 04 select onboarding — capture root; YNS-018–020 / CTS-9205, CTS-9218, CTS-9266 */}
        <div data-testid="a11y-capture--04-onboarding-flow--select">
          <Page />
        </div>
      </SelectOnboardingProvider>
    </QueryClientProvider>
  )
}

export default SelectOnboarding

const Page = () => {
  const { questionIdx } = useSelectOnboarding()
  const hasMountedRef = useRef(false)
  const previousIdxRef = useRef(questionIdx)

  useLayoutEffect(() => {
    if (!hasMountedRef.current) {
      hasMountedRef.current = true
      previousIdxRef.current = questionIdx
      return
    }

    if (previousIdxRef.current === questionIdx) return

    previousIdxRef.current = questionIdx

    if (questionIdx < 1) return

    focusStepOnChange()
  }, [questionIdx])

  if (questionIdx === 0) return <WelcomePage />
  return <FormPage />
}
